export const iconFontAwesomeCommunicationFax = (
	<i className="fa-solid fa-fax"></i>
);
